<template>
  <section class="relative isolate overflow-hidden pt-8 pb-24 sm:pb-32">
    <div class="mx-auto max-w-7xl px-6 lg:px-8">
      <div class="relative isolate overflow-hidden rounded-3xl bg-gray-800 px-6 py-16 sm:px-16 sm:py-24">
        <shape-field origin="center" inverted />

        <div
          data-animate-group
          class="relative mx-auto max-w-3xl text-center"
        >
          <h2
            data-animate="fade-up"
            class="text-balance text-4xl font-display font-bold tracking-tight text-white sm:text-5xl"
          >
            {{ title }}
          </h2>

          <p
            data-animate="fade-up"
            class="mt-6 text-pretty text-lg/8 text-gray-300"
          >
            {{ description }}
          </p>

          <div
            data-animate="fade-up"
            class="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4"
          >
            <button-primary
              :link="primaryLink"
              :label="primaryLabel"
              size="lg"
            />

            <button-secondary
              :link="secondaryLink"
              :label="secondaryLabel"
              size="lg"
              inverted
              icon-name="ph:arrow-right"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
type Props = {
  title?: string,
  description?: string,
  primaryLabel?: string,
  primaryLink?: string,
  secondaryLabel?: string,
  secondaryLink?: string
}

const {
  title = 'Prêt à animer vos écrans\u00A0?',
  description = 'Demandez une démo gratuite et sans engagement. Nous vous accompagnons pour configurer vos premiers écrans en moins d\'une heure.',
  primaryLabel = 'Demander une démo',
  primaryLink = '/demo',
  secondaryLabel = 'Poser une question',
  secondaryLink = '/contact'
} = defineProps<Props>()
</script>
